import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .btn {
    cursor: pointer;
    font-family: "HeeboRegular", sans-serif;
    font-size: 1.8rem;
    font-weight: 400;
    text-decoration: underline;
    margin: auto;
    color: #4f4f4f;
    border: none;
    background: none;
  }
`;

export const Para = styled.p`
  margin: 0;
  padding: 0;

  &.commitment {
    margin-top: 3rem;
  }

  &.commitmentTitle {
    text-align: center;
    font-weight: bold;
    > span {
      text-decoration: underline;
    }
  }

  .bold {
    margin-left: 0.5rem;
  }
`;
